import React from 'react';
import { Outlet } from 'react-router-dom';
import { FarmSettingsContextProvider } from '../contexts/FarmSettingsContext';
import { FarmSourceContextProvider } from '../contexts/FarmSourceContext';
import { InputTypeContextProvider } from '../contexts/InputTypeContext';
import { ItemContextProvider } from '../contexts/ItemContext';
import { MapContextProvider } from '../contexts/MapContext';
import { MultiProjectDashboardContextProvider } from '../contexts/MultiProjectDashboardContext';
import { TilesetContextProvider } from '../contexts/TilesetContext';
import { UnitContextProvider } from '../contexts/UnitContext';
import { AlertContextProvider } from '../contexts/AlertContext';
import { HiddenSectionsContextProvider } from '../contexts/HiddenSectionsContext';
import { UnassignedStemsContextProvider } from '../contexts/UnassignedStemsContext';
import { GlobalModalsContextProvider } from '../contexts/GlobalModalsContext';
import { PortfolioEvaluatorContextProvider } from '../contexts/PortfolioEvaluatorContext';
import ApolloClientProvider from '../components/ApolloClientProvider';
import CombinedProviders from '../components/CombinedProviders';
import Identify from '../components/Identify';
import ToastContainer from '../components/ToastContainer';

const RootLayout = () => {
  return (
    <ApolloClientProvider>
      <Identify />
      <ToastContainer />
      <CombinedProviders
        providers={[
          AlertContextProvider,
          UnitContextProvider,
          MapContextProvider,
          ItemContextProvider,
          InputTypeContextProvider,
          TilesetContextProvider,
          FarmSettingsContextProvider,
          FarmSourceContextProvider,
          HiddenSectionsContextProvider,
          UnassignedStemsContextProvider,
          GlobalModalsContextProvider,
          MultiProjectDashboardContextProvider,
          PortfolioEvaluatorContextProvider,
        ]}
      >
        <Outlet />
      </CombinedProviders>
    </ApolloClientProvider>
  );
};

export default RootLayout;
